export default "__VITE_PUBLIC_ASSET__c9998df3__"